const SET_JANCODE = 'SET_JANCODE'
const CLEAR = 'CLEAR'
let janCode_list

const state = {
    janCode_list: []
}

const getters = {
    janCode_list: state => state.janCode_list ? janCode_list : '',
}

const mutations = {
    [SET_JANCODE] (state, janCode_list) {
        state.janCode_list = janCode_list
    },

    [CLEAR] (state) {
        state.janCode_list = []
    }

}

export const actions = {
    setJanCode({ commit }, { janCode_list }) { 

        commit(SET_JANCODE, janCode_list)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}